const SESSION_KEY = "sootchy_user_session";

export const getDecodedToken = <T>(): T => {
  const raw = localStorage.getItem(SESSION_KEY);
  if (!raw) {
    throw new Error("No user session found");
  }
  return JSON.parse(raw) as T;
};

export const getDecodedTokenSafe = <T>(
  onError?: (error: Error) => void,
): T | null => {
  try {
    return getDecodedToken<T>();
  } catch (error) {
    const errorObj =
      error instanceof Error ? error : new Error("Unknown error occurred");
    if (onError) {
      onError(errorObj);
    }
    return null;
  }
};

// Token refresh is handled server-side by TokenAutoRefreshMiddleware.
// From the client's perspective the session never expires.
export const isTokenExpired = (): boolean => false;
